import { render, staticRenderFns } from "./course-comprehensive-inspection.vue?vue&type=template&id=7abfa976&scoped=true&"
import script from "./course-comprehensive-inspection.vue?vue&type=script&lang=js&"
export * from "./course-comprehensive-inspection.vue?vue&type=script&lang=js&"
import style0 from "./course-comprehensive-inspection.vue?vue&type=style&index=0&id=7abfa976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abfa976",
  null
  
)

export default component.exports